import { Grid, FormControlLabel, Box } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { CheckboxSmall, FieldSetStyles } from "../../styles";
import { SourceType } from "@authory-packages/core";

export type SourceImportWhereAuthorRelationConfProps = {
  importContentFromUser?: boolean;
  onImportContentFromUserChange?: () => void;
  importContentAboutUser?: boolean;
  onImportContentAboutUserChange?: () => void;
  sourceType: SourceType;
  disabled?: boolean;
};

export const SourceImportWhereAuthorRelationConf = ({
  importContentFromUser,
  onImportContentFromUserChange,
  importContentAboutUser,
  onImportContentAboutUserChange,
  sourceType,
  disabled,
}: SourceImportWhereAuthorRelationConfProps) => {
  return (
    <>
      <FormControlLabel
        control={
          <CheckboxSmall
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            name="importContentFromUser"
            checked={importContentFromUser}
            onChange={onImportContentFromUserChange}
            readOnly={sourceType !== SourceType.Web}
            disabled={sourceType !== SourceType.Web || disabled}
          />
        }
        label="From User"
      />
      <FormControlLabel
        control={
          <CheckboxSmall
            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
            checkedIcon={<CheckBoxIcon fontSize="small" />}
            name="importContentAboutUser"
            checked={importContentAboutUser}
            onChange={onImportContentAboutUserChange}
            readOnly={sourceType !== SourceType.Web}
            disabled={sourceType !== SourceType.Web || disabled}
          />
        }
        label="About User"
      />
    </>
  );
};

type SourceAuthorMatchConfProps = {
  skipAuthorCheck: boolean;
  onSkipAuthorCheckChange: () => void;
  ignoreStaticAuthor: boolean;
  onIgnoreStaticAuthor: () => void;
  ignoreDiffbotAuthor: boolean;
  onIgnoreDiffbotAuthorChange: () => void;
  ignoreShivaAuthor: boolean;
  onIgnoreShivaAuthor: () => void;
  disabled?: boolean;
} & SourceImportWhereAuthorRelationConfProps;

export const SourceAuthorMatchConf = ({
  skipAuthorCheck,
  onSkipAuthorCheckChange,
  ignoreStaticAuthor,
  onIgnoreStaticAuthor,
  ignoreDiffbotAuthor,
  onIgnoreDiffbotAuthorChange,
  ignoreShivaAuthor,
  onIgnoreShivaAuthor,
  importContentFromUser,
  onImportContentFromUserChange,
  importContentAboutUser,
  onImportContentAboutUserChange,
  sourceType,
  disabled,
}: SourceAuthorMatchConfProps) => {
  const fieldSetStyles = FieldSetStyles();

  return (
    <fieldset className={fieldSetStyles.container}>
      <legend>Author Match Settings:</legend>
      <Box mt={2}>
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <FormControlLabel
              control={
                <CheckboxSmall
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                  name="skipAuthorCheck"
                  checked={skipAuthorCheck}
                  onChange={onSkipAuthorCheckChange}
                  disabled={disabled}
                />
              }
              label="Skip author check"
            />
          </Grid>
          <Grid item sm={12}>
            <Grid item md={12}>
              <FormControlLabel
                control={
                  <CheckboxSmall
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    name="ignoreStaticAuthor"
                    checked={ignoreStaticAuthor}
                    onChange={onIgnoreStaticAuthor}
                    disabled={disabled}
                  />
                }
                label="Ignore Meta Author"
              />
              <FormControlLabel
                control={
                  <CheckboxSmall
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    name="ignoreDiffbotAuthor"
                    checked={ignoreDiffbotAuthor}
                    onChange={onIgnoreDiffbotAuthorChange}
                    disabled={disabled}
                  />
                }
                label="Ignore Diffbot Author"
              />
              <FormControlLabel
                control={
                  <CheckboxSmall
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                    name="ignoreShivaAuthor"
                    checked={ignoreShivaAuthor}
                    onChange={onIgnoreShivaAuthor}
                    disabled={disabled}
                  />
                }
                label="Ignore Custom Extraction Author"
              />
            </Grid>
            {typeof importContentFromUser !== "undefined" &&
              typeof importContentAboutUser !== "undefined" && (
                <Grid item md={12}>
                  <SourceImportWhereAuthorRelationConf
                    importContentFromUser={importContentFromUser}
                    onImportContentFromUserChange={
                      onImportContentFromUserChange
                    }
                    importContentAboutUser={importContentAboutUser}
                    onImportContentAboutUserChange={
                      onImportContentAboutUserChange
                    }
                    sourceType={sourceType}
                    disabled={disabled}
                  />
                </Grid>
              )}
          </Grid>
        </Grid>
      </Box>
    </fieldset>
  );
};
